import React from 'react';

import './ballBounce.css';

function BallBounce() {
  return (
    <div className="ball"></div>
  )
}

export default BallBounce